// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */
/* eslint-disable camelcase */
// webgen:keep
import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import {
  type EmailRecipient,
  type EmailRecipientWireFormat,
  NewEmailRecipient,
} from '../EmailRecipient/EmailRecipient';
import {
  NewUploadFileInput,
  UploadFileInput,
  type UploadFileInputWireFormat,
} from '../UploadFileInput/UploadFileInput';

export class SendMessageInput {
  readonly body: string;
  readonly subject: string;
  readonly to: EmailRecipient[];
  readonly from: EmailRecipient[];
  readonly cc?: EmailRecipient[];
  readonly bcc?: EmailRecipient[];
  readonly reply_to?: EmailRecipient[];
  readonly file: UploadFileInput;
  readonly files?: UploadFileInput[];
  readonly quoteId?: string;

  constructor(data: { [key: string]: any } = {}) {
    this.body = data.body === undefined ? '' : data.body;
    this.subject = data.subject === undefined ? '' : data.subject;
    this.to = (data.to ?? []).map((to: any) => NewEmailRecipient(to));
    this.from = (data.from ?? []).map((from: any) => NewEmailRecipient(from));
    this.cc = (data.cc ?? []).map((cc: any) => NewEmailRecipient(cc));
    this.bcc = (data.bcc ?? []).map((bcc: any) => NewEmailRecipient(bcc));
    this.reply_to = (data.reply_to ?? []).map((reply_to: any) => NewEmailRecipient(reply_to));
    this.file = NewUploadFileInput(data.file);
    this.files = (data.files ?? []).map((files: any) => NewUploadFileInput(files));
    this.quoteId = data.quoteId;
  }

  static zero(): SendMessageInput {
    const zeroValues: ExcludeMethodsDeep<SendMessageInput> = {
      body: '',
      subject: '',
      to: [],
      from: [],
      file: UploadFileInput.zero(),
    };
    return new SendMessageInput(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type SendMessageInputWireFormat = {
  body: string;
  subject: string;
  to: EmailRecipientWireFormat[];
  from: EmailRecipientWireFormat[];
  cc?: EmailRecipientWireFormat[];
  bcc?: EmailRecipientWireFormat[];
  reply_to?: EmailRecipientWireFormat[];
  file: UploadFileInputWireFormat;
  files?: UploadFileInputWireFormat[];
  quoteId?: string;
};

type NewSendMessageInputProps = PartialDeep<SendMessageInput, { recurseIntoArrays: true }>;
export const NewSendMessageInput: (props: NewSendMessageInputProps) => SendMessageInput = (props) =>
  new SendMessageInput(props);

type NewSendMessageInputFromWireFormatProps = PartialDeep<
  SendMessageInputWireFormat,
  { recurseIntoArrays: true }
>;
export const NewSendMessageInputFromWireFormat: (
  props: NewSendMessageInputFromWireFormatProps,
) => SendMessageInput = (props) => new SendMessageInput(props);
